// @ts-nocheck
/// <reference path="../../../../../rcwebmodels/reeferdetails.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/unitdetailsui.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/dryassetsmgmtmodel.cs.d.ts" />
import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as ReeferStatusState from '../../store/ReeferStatus';
import * as UserDetailState from '../../store/UserDetails';

import { DryDetailsHistory } from '../childcomponents/DryDetailsHistory';
import { DryDetailsCommandStatus } from '../childcomponents/DryDetailsCommandStatus';
import DetailsMap from '../../actions/DetailsMap';

import { RCUtils } from './../../RCUtils';
import $ from 'jquery';

import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { Comments } from './../sharedcomponents/Comments';
import DetailFormatters from '../../actions/ReeferDetailFilters';
import * as Exceljs from '../../actions/ExportToExcel.js';
import moment from 'moment';
import Formatters from '../../actions/Formatters';
import DateFormat from 'dateformat';

var Excel = Exceljs.default;
var Config: any = require('../../Config.json');
var self;

interface DryDetailsState {
    dryDetailsData: any;
    dryHistoryData: server.DryHistoryUI[];
    rcdHistoryData: server.RcdHistoryUI[],
    dryCommandsData: server.DryCommandStatusUI[];
    dryDetailsSearch: DryDetailsFilter;
    DryId: string;
    RcdId: string;
    preTripCmd: string;
    selectedDryData: any[];
    modelTitle: string;
    popUpHtml: any;
    isChangeDeforstInterval: boolean;
    isLoading: boolean;
    enableTab: boolean;
    DataSource: string;
    reeferFormatter: server.ReeferFormatter;
    preTripData: string;
    tabContentHtml: any;
    searchInputValue: string;
    assetMasterID: number;//WI-23781
    isOpenVia: any;
    isDevice: boolean;
    fromDateHistory: string;
    toDateHistory: string;
    fromRCDDateHistory: string;
    toRCDDateHistory: string;
    fromDateCommandHistory: string;
    toDateCommandHistory: string;
}

var tempFormat;
var timeZoneCd;
var self;
var restricted = false;
type DryStatusProps =
    UserDetailState.UserState
    & ReeferStatusState.ReeferSearchState       // ... state we've requested from the Redux store     
    & typeof ReeferStatusState.actionCreators      // ... plus action creators we've requested
    & RouteComponentProps<{}>; // ... plus incoming routing parameters

interface AssetState {
    dryDetails: server.DryDetailsUI;
    modelTitleReport: string;
    popUpHtmlReport: any;
    PTReport: string;
    assetMasterID: number;//WI-23781
    isOpenVia: any;
    isDevice: boolean;
    geoZonesEnabled: boolean;
    geoZonesImage: boolean;
}

export class CurrentStatus extends React.Component<any, AssetState>{
    constructor(props: any) {
        super(props);
        this.state = {
            dryDetails: this.props.assetData, modelTitleReport: '', popUpHtmlReport: '', PTReport: this.props.preTripReport,
            assetMasterID: this.props.AssetMasterID, isOpenVia: this.props.isOpenVia, isDevice: this.props.isDevice,
            geoZonesEnabled: true, geoZonesImage: true
        };
    }

    componentDidMount() {
        var authRight = RCUtils.CheckAssesRightsForDrys('159');
        if (!authRight) { this.props.history.push('/AccessDenied'); } else {
            DetailsMap.InitDetailsMap("dryStatusMap");
            setTimeout(() => {
                DetailsMap.LoadDetailsMap(this.state.dryDetails.Latitude, this.state.dryDetails.Longitude);
            }, 1000);
            this.formatGPSLatLong(this.state.dryDetails);
            this.updateDryCommandsDimensions();
            window.addEventListener("resize", this.updateDryCommandsDimensions.bind(this));

            if (this.state.isOpenVia === "CurrentDetails") {
                if ($("#collapseOne").hasClass("show")) {
                    $('#collapseOne').removeClass('show');
                }
                if (!$("#collapseTwo").hasClass("show")) {
                    $('#collapseTwo').addClass('show');
                }
                if ($("#collapseThree").hasClass("show")) {
                    $('#collapseThree').removeClass('show');
                }
            }
            else if (this.state.isOpenVia === "Comments") {
                if ($("#collapseOne").hasClass("show")) {
                    $('#collapseOne').removeClass('show');
                }
                if ($("#collapseTwo").hasClass("show")) {
                    $('#collapseTwo').removeClass('show');
                }
                if (!$("#collapseThree").hasClass("show")) {
                    $('#collapseThree').addClass('show');
                }

            } else if (this.state.isOpenVia === "RcdStatus") {
                if (!$("#collapseOne").hasClass("show")) {
                    $('#collapseOne').addClass('show');
                }
                if ($("#collapseTwo").hasClass("show")) {
                    $('#collapseTwo').removeClass('show');
                }
                if ($("#collapseThree").hasClass("show")) {
                    $('#collapseThree').removeClass('show');
                }
            }
            else if (this.state.isOpenVia === null || this.state.isOpenVia === undefined) {
                if (!$("#collapseOne").hasClass("show")) {
                    $('#collapseOne').addClass('show');
                }
                if ($("#collapseTwo").hasClass("show")) {
                    $('#collapseTwo').removeClass('show');
                }
                if ($("#collapseThree").hasClass("show")) {
                    $('#collapseThree').removeClass('show');
                }
            }

            this.showTabPane(this.props.isDryOrRCD);
        }
    }

    showTabPane(isDryOrRCD: string) {
        if (isDryOrRCD != null && isDryOrRCD != undefined && isDryOrRCD != '') {
            if (isDryOrRCD == "Dry") {
                if ($('#detailsPane').attr('aria-expanded') == "false")
                    $('#detailsPane').click();
            }
        }
    }

    formatGPSLatLong(params: any) {
        $("#gpsLongitude").removeClass('gpslatlong');
        $("#gpsLatitude").removeClass('gpslatlong');
        if (params.Latitude != 0 && params.Longitude != 0 && (params.GPSLockState == null || params.GPSLockState == '' || params.GPSLockState.toUpperCase() != "LOCKED")) {
            if (params.Longitude != null)
                $("#gpsLongitude").addClass('gpslatlong');

            if (params.Latitude != null)
                $("#gpsLatitude").addClass('gpslatlong');
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.assetData != null && nextProps.assetData != "") {
            this.setState({
                dryDetails: nextProps.assetData,
                assetMasterID: nextProps.AssetMasterID,//WI-23781
                isDevice: nextProps.isDevice
            });

            if (nextProps.isDevice && nextProps.isOpenVia != "Comments") {
                if (!$("#collapseOne").hasClass("show")) {
                    $('#collapseOne').addClass('show');
                }
                if ($("#collapseTwo").hasClass("show")) {
                    $('#collapseTwo').removeClass('show');
                }
                if ($("#collapseThree").hasClass("show")) {
                    $('#collapseThree').removeClass('show');
                }
            }
            else if (!nextProps.isDevice && nextProps.isOpenVia != "Comments") {
                if ($("#collapseOne").hasClass("show")) {
                    $('#collapseOne').removeClass('show');
                }
                if (!$("#collapseTwo").hasClass("show")) {
                    $('#collapseTwo').addClass('show');
                }
                if ($("#collapseThree").hasClass("show")) {
                    $('#collapseThree').removeClass('show');
                }
            }
            else if (this.state.isOpenVia === null || this.state.isOpenVia === undefined) {
                if (!$("#collapseOne").hasClass("show")) {
                    $('#collapseOne').addClass('show');
                }
                if ($("#collapseTwo").hasClass("show")) {
                    $('#collapseTwo').removeClass('show');
                }
                if ($("#collapseThree").hasClass("show")) {
                    $('#collapseThree').removeClass('show');
                }
            }

            this.showTabPane(nextProps.isDryOrRCD);
            DetailsMap.LoadDetailsMap(nextProps.assetData.Latitude, nextProps.assetData.Longitude);
            this.formatGPSLatLong(nextProps.assetData);
        }

        if (nextProps.preTripReport != null && nextProps.preTripReport != "") {
            this.setState({
                PTReport: nextProps.preTripReport
            });
        }
        else {
            this.setState({ PTReport: null });
        }
    }

    //componentWillUnmount() {
    //    window.removeEventListener("resize", this.updateDryCommandsDimensions.bind(this));
    //}

    updateDryCommandsDimensions() {
        $(".dynamicHeight").css('min-height', $(window).height() - 190);
        $(".dynamicHeight").css('max-height', $(window).height() - 190);
        $("#dryStatusMap").css('min-height', $(window).height() - 210);
        $("#dryStatusMap").css('max-height', $(window).height() - 210);

    }

    showGeoZonesLayer() {
        this.setState({ geoZonesEnabled: false });
        DetailsMap.BindGeoZonesLayer(this.state.dryDetails.Latitude, this.state.dryDetails.Longitude, this.state.dryDetails.PositionAccuracy);
    }

   hideGeoZonesLayer() {
        this.setState({ geoZonesEnabled: true });
        DetailsMap.DisposeGeozonesLayer();
    }

    static UpdateFenceImage(src:any) {
        if (src == "A")
            self.setState({ geoZonesImage: false });
        else
            self.setState({ geoZonesImage: true });
    }


    public render() {
        return <>
            <div className='row'>
                <div className='col-md-4 col-lg-4 position-relative'>
                    <div id='geoZones' className='dryDetails-geoZones'>
                        {
                            this.state.geoZonesEnabled == true ? <span title='Show Accuracy' class={this.state.geoZonesImage == true ? "fa-regular fa-bullseye-arrow target-icon opacity-25" : "fa-regular fa-bullseye-arrow target-icon text-white"} onClick={this.showGeoZonesLayer.bind(this)}></span>
                                : <span title='Hide Accuracy' class={this.state.geoZonesImage == true ? "fa-regular fa-bullseye-arrow target-icon" : "fa-regular fa-bullseye-arrow target-icon text-white"} onClick={this.hideGeoZonesLayer.bind(this)}></span>
                        }
                    </div>
                    <div id="dryStatusMap" className='pb-2'></div>
                   
                </div>
                <div className='col-md-8 col-lg-8 ps-0'>
                    <div className="accordion" id="accordion">
                        <div hidden={restricted}>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                       Device details
                                    </button>
                                </h2>
                                <div id="collapseOne" className="accordion-collapse collapse show">
                                    <div className="accordion-body">
                                        <div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>Device ID </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.RCDID}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Loc age (h:m:s) </div>
                                                <div className='col-md-2 px-2 pt-1'>{DetailFormatters.SecondsToTimeConverter(this.state.dryDetails.GPSLastLock)}</div>
                                                {/* <div className='col-md-2 pt-1 fw-medium'>Battery (V):</div>
                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.BattVoltageFormatter(this.state.dryDetails.ExtBattVoltage)}</div>
                                            **/}
                                                <div className='col-md-2 pt-1 fw-medium'>MCC (country) </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.CountryName}</div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>Device type </div>
                                                <div className='col-md-2 px-2 pt-1'>{DetailFormatters.StringFormater(this.state.dryDetails.DeviceType)}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Loc HDOP </div>
                                                <div className='col-md-2 px-2 pt-1'>{DetailFormatters.GPSHDOPFormatter(this.state.dryDetails.DryGPSHDOP, this.state.dryDetails.GPSLockState)}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>MNC </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.MNC}</div>

                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>Device FW ver </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.FirmwareVersion}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Loc sat ct </div>
                                                <div className='col-md-2 px-2 pt-1'>{DetailFormatters.GPSSatCountFloatFormatter(this.state.dryDetails.DryGPSSatelliteCount, this.state.dryDetails.GPSLockState)}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>LAC </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.TowerLocalizationAreaCode}</div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>MSISDN </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.MSISDN}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Latitude </div>
                                                <div className='col-md-2 px-2 pt-1'>{DetailFormatters.GPSLatitudeFormatter(this.state.dryDetails)}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Tower ID </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.TowerBaseStationID}</div>

                                            </div>

                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>IMSI </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.SIM_IMSI}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Longitude </div>
                                                <div className='col-md-2 px-2 pt-1'>{DetailFormatters.GPSLongitudeFormatter(this.state.dryDetails)}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Device fence </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.FenceName}</div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>ICCID </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.ICCID}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>City </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.City}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Server fence </div>
                                                <div className='col-md-2 px-2 pt-1 ReeferDetails-ellipsis' title={this.state.dryDetails.BackendGeofenceName}>{this.state.dryDetails.BackendGeofenceName}</div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>EUI </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.EUI}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>State </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.State}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Geofence revision</div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.GeofenceDefinitionRevision}</div>

                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>Reporting (stationary)</div>
                                                <div className='col-md-2 px-2 pt-1'>{DetailFormatters.StringFormater(this.state.dryDetails.StationaryReportingInterval)}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Zip code</div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.ZipCode}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>BATT</div>
                                                <div className='col-md-2 px-2 pt-1 pwr_device_details'>
                                                    <img className='Rssiformatter' src={DetailFormatters.DryBatteryPctFormatter(this.state.dryDetails.BatteryPct)}></img>
                                                </div>

                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>Reporting (moving) </div>
                                                <div className='col-md-2 px-2 pt-1'>{DetailFormatters.StringFormater(this.state.dryDetails.RCDReportingInterval)}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Country </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.Country}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Cell signal </div>
                                                <div className='col-md-2 px-2 pt-1'>
                                                    <img className='Rssiformatter' src={DetailFormatters.RSSIFormatter(this.state.dryDetails.RSSI)}></img>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item rounded-0">

                                <h2 className="accordion-header">
                                    <button className="accordion-button rounded-0 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        Dry details
                                    </button>
                                </h2>

                                <div id="collapseTwo" className="accordion-collapse collapse">
                                    <div className="accordion-body">
                                        {
                                            (this.state.dryDetails.AssetNumber != null || this.state.dryDetails.RCDID == undefined || this.state.dryDetails.RCDID == null) ?
                                                <div>
                                                    <div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Dry ID </div>
                                                            <div className='col-md-2 px-2 pt-1'>{this.state.dryDetails.AssetNumber}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Last event </div>
                                                            <div className='col-md-2 px-2 pt-1 text-truncate' title={this.state.dryDetails.EventDescription}>{this.state.dryDetails.EventDescription}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Trip name </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.StringFormater(this.state.dryDetails.TripName)}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Door </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.DryDoorFormatter(this.state.dryDetails)}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Event time {timeZoneCd} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.DateTypeFormatter(this.state.dryDetails.EventDTTM)}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Trip status </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.StringFormater(this.state.dryDetails.TripStatus)}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Speed (mph) </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.SpeedConverter(this.state.dryDetails.DrySpeed)}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Device data {timeZoneCd} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.DateTypeFormatter(this.state.dryDetails.DeviceDataTime)}</div>
                                                        </div>
                                                    </div>
                                                </div> : <div className='alert alert-info'> No association exist </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='alert alert-info' hidden={!restricted}>Current Details not available</div>
                        <div id="CommenstId">
                            <div><Comments reeferData={this.state.dryDetails} AssetMasterID={this.state.assetMasterID} ></Comments></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }
}

class DryDetails extends React.Component<DryStatusProps, DryDetailsState> {
    constructor(props: any) {
        super(props);
        self = this;
        var filterSet = new DryDetailsFilter();
        var dryId = null;
        var rcdId = null;
        var isOpenVia = null;
        var isDevice = false;
        if (this.props.location.state != null && this.props.location.state != undefined) {
            var params = this.props.location.state.dryData;
            var dataSource = this.props.location.state.source;
            isOpenVia = this.props.location.state.isOpenVia;

            if (this.props.location.state.isDevice != null && this.props.location.state.isDevice != undefined)
                isDevice = this.props.location.state.isDevice;
            else
                isDevice = false;

            if (params != null && params != undefined) {
                if (dataSource == "Device")
                    rcdId = params.RCDID;
                else {
                    dryId = params.AssetNumber;
                    rcdId = params.RCDID;
                }
            }
        }

        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        var toDTTM = Formatters.DateTimeFormatter(currentUtcDttm)
        var modifiedDttm = new Date(toDTTM);
        modifiedDttm.setDate(modifiedDttm.getDate() - 1);
        var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');

        var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
        var toDate = moment(new Date(toDTTM)).endOf('day').toString();

        var fromCommandDate = moment(new Date(toDate)).startOf('day').toString();
        var toCommandDate = moment(new Date(toDate)).endOf('day').toString();


        this.state = {
            dryDetailsData: new DryDetailsUI(), dryHistoryData: [], rcdHistoryData: [], dryCommandsData: [], dryDetailsSearch: filterSet, DryId: dryId, RcdId: rcdId, preTripCmd: null, selectedDryData: [], modelTitle: '', popUpHtml: '', isChangeDeforstInterval: false, isLoading: true, enableTab: false, DataSource: dataSource, reeferFormatter: null, preTripData: null, tabContentHtml: '', searchInputValue: '', assetMasterID: 0, isOpenVia: isOpenVia
            , isDevice: isDevice
            , fromDateHistory: DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM')
            , toDateHistory: DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM')
            , fromDateCommandHistory: DateFormat(new Date(fromCommandDate), 'mm/dd/yyyy HH:MM')
            , toDateCommandHistory: DateFormat(new Date(toCommandDate), 'mm/dd/yyyy HH:MM')
            , fromRCDDateHistory: DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM')
            , toRCDDateHistory: DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM')
        };
        this.GetDryDetailsSearchData();
        tempFormat = DetailFormatters.GetTempColumnFormatter();
        timeZoneCd = DetailFormatters.GetTimeZoneFormatter();
        restricted = false;
    }

    updateDryCommandsDimensions() {
        $(".dynamicHeight").css('min-height', $(window).height() - 158);
        $(".dynamicHeight").css('max-height', $(window).height() - 158);
    }

    GetSelectedDryData() {
        $('#globalLoader').show();
        var drySearchFilters: server.ReeferSearchFilters = {
            SelectedOem: '', SelectedCountry: '', SelectedReefer: this.state.DryId, SelectedGeofence: '', SelectedInterval: '', SelectedGeofenceInside: '', SelectedVesselCode: '', StatusFilters: [], AllReefers: '', CustomAttributeFilters: null, SelectedAssetTypes: '', SelectedAssetStates: '',
            SelectedBookingNumber: '', SelectedVesselCD: '', SelectedCall: '', SelectedVoyage: '', SelectedCargoCareProfiles: '', SelectedPod: '', SelectedPol: '', SelectedCTProfileIds: [] //WI-26881
        };
        var childRequest = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/DryStatusDataSP', { method: 'POST', body: JSON.stringify(drySearchFilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(childRequest)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.DryStatusData[]>)
            .then(childData => {
                $('#globalLoader').hide();
                if (childData != null && childData != undefined && childData.length > 0) {
                    var dryData = [];
                    dryData.push(childData[0]);
                    this.setState({
                        selectedDryData: dryData,
                        isLoading: false
                    }, () => this.ShowFirstTab());
                }
                else {
                    this.ShowFirstTab();
                }
            });
    }

    ShowFirstTab() {
        $('.nav-tabs a:first').click();
        this.setState({ tabContentHtml: this.renderTabContentHtml(1) });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDryCommandsDimensions.bind(this));
    }

    componentDidMount() {
        this.ShowFirstTab();
        if (this.state.DryId == null && this.state.RcdId == null)
            this.setState({ isLoading: false });
        else {
            if (this.state.DryId != null && this.state.DryId != undefined && this.state.DryId != '' && this.state.DataSource == "Dry") {
                this.setState({ searchInputValue: this.state.DryId });
            }
            else if (this.state.RcdId != null && this.state.RcdId != undefined && this.state.RcdId != '' && this.state.DataSource == "Device") {
                this.setState({ searchInputValue: this.state.RcdId });
            }
            else {
                if (this.state.DryId != null && this.state.DryId != undefined && this.state.DryId != '') {
                    this.setState({ searchInputValue: this.state.DryId });
                }
                else if (this.state.RcdId != null && this.state.RcdId != undefined && this.state.RcdId != '') {
                    this.setState({ searchInputValue: this.state.RcdId });
                }
            }
        }

        this.updateDryCommandsDimensions();
        window.addEventListener("resize", this.updateDryCommandsDimensions.bind(this));
        Excel.draggableModalPopup(document.getElementById("contextMenuModel"));
        $('#Command').hide();
        //$('.nav-tabs a').on('shown.bs.tab', function (event) {
        $(".nav-tabs a").click(function (event) {
            var targetId = event.target.id;
            if (targetId == 'lnkCurrentStatus') {
                self.renderTabContent(1);
            }
            else if (targetId == 'lnkHistory') {
                self.renderTabContent(2);
            }
            else {
                self.renderTabContent(3);
            }
        });
    }

    renderTabContent(tabNumber: number) {
        this.setState({ tabContentHtml: this.renderTabContentHtml(tabNumber) });
    }

    renderTabContentHtml(tabNumber: number) {
        if (tabNumber == 1) {
            return <div className="tab-pane fade show active dynamicHeight" id="asset">
                <CurrentStatus assetData={this.state.dryDetailsData} preTripReport={this.state.preTripData} isDryOrRCD={this.state.DataSource} AssetMasterID={this.state.assetMasterID} isOpenVia={this.state.isOpenVia}
                    isDevice={this.state.isDevice}></CurrentStatus>
            </div>;
        }
        else if (tabNumber == 2) {
            if (this.state.DryId != null && this.state.DryId != "") {
                return <div className="tab-pane fade show active dynamicHeight" id="history">
                    <div><DryDetailsHistory stateData={this.state} IsDry={true}
                        FromDate={this.state.fromDateHistory} ToDate={this.state.toDateHistory}
                        HoldHistoryDates={this.HoldHistoryDates.bind(this)}
                        HoldHistoryData={this.HoldHistoryData.bind(this)}
                    ></DryDetailsHistory></div>
                </div>;
            }
            else {
                return <div className="tab-pane fade show active dynamicHeight" id="history">
                    <div><DryDetailsHistory stateData={this.state} IsDry={false}
                        FromDateRCD={this.state.fromRCDDateHistory} ToDateRCD={this.state.toRCDDateHistory}
                        HoldRCDHistoryDates={this.HoldRCDHistoryDates.bind(this)}
                        HoldHistoryData={this.HoldHistoryData.bind(this)}
                    ></DryDetailsHistory></div>
                </div>;
            }
        }
        else {
            return <div className="tab-pane fade show active dynamicHeight" id="commands">
                <div><DryDetailsCommandStatus stateData={this.state}
                    FromDate={this.state.fromDateCommandHistory} ToDate={this.state.toDateCommandHistory}
                    HoldCommandHistoryDates={this.HoldCommandHistoryDates.bind(this)}
                    HoldCommandHistoryData={this.HoldCommandHistoryData.bind(this)}></DryDetailsCommandStatus></div>
            </div>;
        }
    }

    HoldHistoryDates(fromDate: Date, toDate: Date) {
        if (fromDate === null && toDate != null) {
            this.setState({ toDateHistory: toDate.toString() });
        }
        if (fromDate != null && toDate === null) {
            this.setState({ fromDateHistory: fromDate.toString() });
        }
    }
    HoldRCDHistoryDates(fromDate: Date, toDate: Date) {
        if (fromDate === null && toDate != null) {
            this.setState({ toRCDDateHistory: toDate.toString() });
        }
        if (fromDate != null && toDate === null) {
            this.setState({ fromRCDDateHistory: fromDate.toString() });
        }
    }

    HoldCommandHistoryDates(fromDate: Date, toDate: Date) {
        if (fromDate === null && toDate != null) {
            this.setState({ toDateCommandHistory: toDate.toString() });
        }
        if (fromDate != null && toDate === null) {
            this.setState({ fromDateCommandHistory: fromDate.toString() });
        }
    }

    HoldHistoryData(reeferFormatter: server.ReeferFormatter, dryHistoryData: server.DryHistoryUI[],
        rcdHistoryData: server.RcdHistoryUI[]) {

        this.setState({
            dryHistoryData: dryHistoryData,
            reeferFormatter: reeferFormatter,
            rcdHistoryData: rcdHistoryData
        });
    }

    HoldCommandHistoryData(dryCommandsData: server.DryCommandStatusUI[]) {

        this.setState({
            dryCommandsData: dryCommandsData
        });
    }

    Drychange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value;
        var inputValue = Value;

        self.setState({
            searchInputValue: inputValue
        });
    }

    GetDryDetailsSearchData() {
        var filterSet = new DryDetailsFilter();
        //if (this.state.DataSource == null || this.state.DataSource == undefined) {
        //    if (this.state.DryId == null) {
        //        filterSet.DryId = this.state.DryId;
        //        filterSet.RcdId = this.state.RcdId;
        //    }
        //    else if (this.state.DryId.length <= 11) {
        //        filterSet.DryId = this.state.DryId;
        //    }
        //    else if (this.state.DryId.length > 11) {
        //        filterSet.RcdId = this.state.RcdId;
        //    }
        //}
        //else {
        //    filterSet.DryId = this.state.DryId;
        //    filterSet.RcdId = this.state.RcdId;
        //}

        filterSet.DryId = this.state.DryId;
        filterSet.RcdId = this.state.RcdId;

        if (this.state.DryId != null || this.state.RcdId != null) {
            $('#globalLoader').show();
            this.setState({ dryDetailsSearch: filterSet });
            var filterParams = JSON.stringify(filterSet);

            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/DryDetailsDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.DryDetails>)
                .then(data => {
                    $('#globalLoader').hide();
                    // if (data.DryDetailsUI.RCDID != null) {
                    if ((data.DryDetailsUI.IsValid3P == true && data.DryDetailsUI.AggRestricted == false) || (data.DryDetailsUI.IsValid3P == true && data.DryDetailsUI.AggRestricted == true && data.DryDetailsUI.AggApplied == true)) {
                        restricted = false;
                        this.setState({
                            dryDetailsData: data.DryDetailsUI,
                            dryHistoryData: data.DryHistoryUI,
                            dryCommandsData: data.DryCommandStatus,
                            rcdHistoryData: data.RcdHistory,
                            assetMasterID: data.AssetMasterID//WI-23781
                        });
                    }
                    else {
                        restricted = true;
                        var dryDetails = new DryDetailsUI();
                        dryDetails.AssetMasterID = data.DryDetailsUI.AssetMasterID;
                        dryDetails.AssetNumber = data.DryDetailsUI.AssetNumber;
                        dryDetails.RCDMasterID = data.DryDetailsUI.RCDMasterID;
                        dryDetails.RCDID = data.DryDetailsUI.RCDID;
                        this.setState({
                            dryDetailsData: dryDetails,
                            dryHistoryData: data.DryHistoryUI,
                            dryCommandsData: data.DryCommandStatus,
                            rcdHistoryData: data.RcdHistory,
                            assetMasterID: data.AssetMasterID//WI-23781
                        });
                        //PopupWindow.showErrorMessage("Error", "Current Details not avaialble");
                    }

                    if (data.DryDetailsUI.AssetNumber != null) {
                        this.GetSelectedDryData();
                    }
                    else {
                        this.ShowFirstTab();
                    }
                    //}
                    //else {
                    //   // restricted = false;
                    //   // this.ClearDryDetails();
                    //   // this.setState({ DryId: this.state.dryDetailsData.AssetNumber, isLoading: false }, () => this.ShowFirstTab());
                    //  //  PopupWindow.showErrorMessage("Error", "Please enter valid Dry/Device ID");
                    //    return;
                    //}
                });
        }
    }

    ClearDryDetails() {
        this.setState({
            dryDetailsData: new DryDetailsUI(),
            dryHistoryData: [],
            dryCommandsData: [],
            rcdHistoryData: [],
            preTripData: null,
            assetMasterID: 0
        });
    }

    ApplySearch() {
        this.setState({ isLoading: true, enableTab: false });
        self.GetDryDetailsSearchData();
    }

    ApplyDryDetailsSearch() {
        if (this.state.searchInputValue != null && this.state.searchInputValue != undefined && this.state.searchInputValue != '') {
            $('#globalLoader').show();
            var validateFilters: server.InputParamsDetails = { Input: this.state.searchInputValue };
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/ValidateDryAssetRCDInputType', { method: 'POST', body: JSON.stringify(validateFilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.ValidateAssetRCDInput>)
                .then(data => {
                    if (data.InputType == "Asset") {
                        this.setState({ DryId: this.state.searchInputValue, RcdId: null, isDevice: false, isOpenVia: null }, () => this.ApplySearch())
                    }
                    else if (data.InputType == "RCD") {
                        this.setState({ RcdId: this.state.searchInputValue, DryId: null, isDevice: true, isOpenVia: null }, () => this.ApplySearch())
                    }
                    else {
                        this.ClearDryDetails();
                        this.setState({
                            DryId: this.state.dryDetailsData.AssetNumber, isLoading: false, assetMasterID: 0
                            , isDevice: false, isOpenVia: null
                        }, () => this.ShowFirstTab());
                        $('#globalLoader').hide();
                        PopupWindow.showErrorMessage("Error", "Please enter valid Dry/Device ID");
                    }
                });
        }
        else {
            PopupWindow.showErrorMessage("Error", "Please enter Dry/Device ID"); return;
        }
    }

    static refreshDryDetailsData() {
        self.setState({ isLoading: true, enableTab: true });
        self.GetDryDetailsSearchData();
    }



    public render() {
        var enableCommands = '';
        if (this.state.dryDetailsData.AssetNumber == "" || this.state.dryDetailsData.AssetNumber == null)
            enableCommands = 'disabled';
        else
            enableCommands = '';

        return <div>
            <div className="row">
                <div className='col-md-12'>
                    <div className="innerpages-heading">

                        {
                            window.location.search != undefined && window.location.search != null && window.location.href != undefined &&
                                window.location.href != null && window.location.href.includes('home')
                                ?
                                <div>
                                    <Link to={'/home'}>
                                        <span className='fa-solid fa-chevron-left one-step-back' title="Back"></span>
                                    </Link>
                                    Current Details
                                </div>

                                :
                                window.location.search != undefined && window.location.search != null && window.location.href != undefined &&
                                    window.location.href != null && window.location.href.includes('drystatus')

                                    ?
                                    <div>
                                        <Link to={'/drystatus?From=' + window.location.pathname.replace('/', '')}>
                                            <span className='fa-solid fa-chevron-left one-step-back' title="Back"></span>
                                        </Link>
                                        Current Details
                                    </div>
                                    :
                                    <div>
                                        <Link to={'/rcdstatus?From=' + window.location.pathname.replace('/', '')}>
                                            <span className='fa-solid fa-chevron-left one-step-back' title="Back"></span>
                                        </Link>
                                        Current Details
                                    </div>
                        }

                    </div>
                </div>
            </div>
            <div className='page-controls-container' id='reefer-details-well'>
                <div className='row'>
                    <div className='col-lg-2 text-end'>
                        <label className='col-form-label' >Dry/Device ID :</label>
                    </div>
                    <div className='col-lg-2'>
                     
                            <input type='text' className='form-control height34' placeholder='Dry/Device ID' onChange={e => this.Drychange(e)} value={this.state.searchInputValue} />
                      
                    </div>
                    <div className='col-lg-1'>
                       
                            <button type='button' className='btn btn-primary' onClick={this.ApplyDryDetailsSearch.bind(this)}>Search</button>
                        
                    </div>
                 
                  
                </div>
                <div className='row'>
                    <div className="modal fade" id="contextMenuModel" role="dialog">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header" id="contextMenuModelHeader">
                                    <h5 className="modal-title">{this.state.modelTitle}</h5>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>
                                    
                                </div>
                                <div className="modal-body">
                                    {this.state.popUpHtml}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id='reefer-details-tab'>
                <ul className="nav nav-underline" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="lnkCurrentStatus" data-bs-toggle="tab" data-bs-target="#tabContentBlock" type="button" role="tab" aria-selected="true">Current Status</button>

                    </li>
                    <li className="nav-item d-none" role="presentation">
                        <button className="nav-link active" id="lnkHistory" data-bs-toggle="tab" data-bs-target="#tabContentBlock" type="button" role="tab" aria-selected="true">History</button>
                       
                    </li>
                    {/*
                    <li>
                    <button className="nav-link" id="lnkCommandStatus" data-bs-toggle="pill" data-bs-target="#tabContentBlock" type="button" role="tab" aria-selected="true">Command Status</button>
                   
                    </li>
                    */}
                </ul>
                <div id="tabContentBlock" className="tab-content">
                    {this.state.tabContentHtml}
                </div>
            </div>
        </div>
    }
}

export default connect(
    (state: ApplicationState) => ({ ...state.userDetails, ...state.reeferStatus }), // Selects which state properties are merged into the component's props
    ReeferStatusState.actionCreators,
)(DryDetails as any);

class DryDetailsFilter {
    DryId: string;
    RcdId: string;
}
class DryDetailsUI {
    DCCurrentConditionId?: number;
    EventDTTM?: Date;
    StrEventDTTM: string;
    Latitude?: number;
    Longitude?: number;
    EventCD: string;
    IsAlarm?: boolean;
    CreatedDTTM?: Date;
    RCDID: string;
    RCDMasterID?: number;
    FirmwareVersion: string;
    EventDescription: string;
    AssetNumber: string;
    Heading: string;
    Speed?: number;
    PowerUpMode: string;
    GPSHDOP?: number;
    GPSSatelliteCount?: number;
    GPSLockState: string;
    GeofenceDefinitionRevision?: number;
    GPSDTTM?: Date;
    StrGPSDTTM: string;
    IgnitionOn?: boolean;
    BattVoltage?: number;
    LSCallFlag: string;
    ExtBattVoltage?: number;
    RSSI?: number;
    ManufacturedDate?: Date;
    FenceID: string;
    FenceName: string;
    City: string;
    State: string;
    RegionGeofenceName: string;
    BackendGeofenceName: string;
    HasAlarm?: boolean;
    Country: string;
    ZipCode: string;
    CustomerName: string;
    GPSCoords: string;
    OEMTypeCD: string;
    ModelNumber: string;
    Profile: string;
    IdPlate: string;
    Assigned: string;
    EngineType: string;
    CountryName: string;
    MNC: string;
    TowerLocalizationAreaCode: string;
    TowerBaseStationID: string;
    RCDReportingInterval: string;
    MSISDN: string;
    SIM_IMSI: string;
    ICCID: string;
    EUI: string;
    DeviceConfig?: boolean;
    DeviceType: string;
    CommentExistsGenset: string;
    CCSeverityLevelGenset: string;
    VesselCd: string;
    GPSLastLock?: number;
    FenceNameID: string;
    RegionGeofenceNameID: string;
    BackendGeofenceNameID: string;
    RCDBootloaderVersion: string;
    RCDMeshFirmwareVersion: string;
    AssetMasterID?: number;
    Alerts: string;
    DeviceDataTime?: Date;
    PositionAccuracy?: number;
    BatteryPct: number;
}

